import moment from 'moment-timezone';
import { DATE_STYLES, getMomentFormat } from 'utils/dateFormats';

/**
 * Formats a given date into a human-readable string based on the specified timezone.
 *
 * @param {string|Date} [date] - The date to be formatted. Accepts a date object or a date string.
 * @param {string} [timezone] - The timezone identifier used to convert the date (e.g., "America/New_York").
 *                             If not provided, the local timezone will be used.
 * @returns {string} The formatted date string in a human-readable format based on the specified timezone.
 *                   Returns '-' if the date is not provided.
 */
export const displayHumanDate = (date, timezone) => {
    if (!date) return '-';

    const momentDate = moment.utc(date);

    if (timezone) {
        return momentDate.tz(timezone).format(getMomentFormat(DATE_STYLES.HUMAN_DATE_TIME_TZ));
    }

    return momentDate.local().format(getMomentFormat(DATE_STYLES.HUMAN_DATE_TIME_TZ));
};
